import React from 'react';
import { connect } from 'react-redux';
import './style.css';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import {Icon, Form, Select, DatePicker, TimePicker, Input, Tooltip, Button, message, Divider} from 'antd';
import {InputItem, List} from 'antd-mobile';
import { fetchLeaveType } from '../../actions/employee-actions';
import applicationCenterService from '../../services/Employee/application-center-service';
import {store} from "../../store/store";
import {push} from "react-router-redux";
// import { Link } from 'react-router-dom';
const { TextArea } = Input;
class ChangePassword extends React.Component {

    componentWillMount() {
        this.props.fetchLeaveType();
    }
    submitApplyModal = () => {
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let posts = {
                    ...values
                }
                // console.log(posts);
                applicationCenterService.changePassword(posts, res => {
                    if (res.data.Success) {
                        message.success("更改密码操作成功 Change Password Success", 4);
                        store.dispatch(push('/employee/employee-home'));
                    }else{
                        message.error(`更改密码操作失败 Change Password Faild：${res.data.Errors[0]}`);
                    }
                }, err => {});
            }
        })
    }
    render() {
        const { employeeLeaveType } = this.props.employee;
        return (
            <div className="app-module-item">
                <div className="remindingImportant">更改密码 Change Password</div>

                <Form onSubmit={this.submitApplyModal} className="login-form" layout="inline">

                    <div  className="Applys">
                        <Form.Item label="当前密码">
                            {this.props.form.getFieldDecorator("OldPassword", {
                                rules: [{
                                    required:true
                                }
                                ]
                            })(<Input disabled={this.readOnly} type="password" style={{width: "360px"}} />)}
                        </Form.Item>
                    </div>
                    <div  className="ApplyDiv">
                        <Form.Item label="新密码">
                            {this.props.form.getFieldDecorator("Password", {
                                rules: [{
                                    required:true
                                }
                                ]
                            })(<Input disabled={this.readOnly} type="password" style={{width: "360px"}} />)}
                        </Form.Item>
                    </div>
                    <div  className="ApplyDiv">
                        <Form.Item label="确认新密码">
                            {this.props.form.getFieldDecorator("ConfirmPassword", {
                                rules: [{
                                    required:true
                                }
                                ]
                            })(<Input disabled={this.readOnly} type="password" style={{width: "360px"}} />)}
                        </Form.Item>
                    </div>
                    <div className="ApplySubmit">
                        <Button type="primary"  onClick={this.submitApplyModal}>
                            <Icon type="check" />
                            <span>提交 Submit</span>
                        </Button>
                    </div>
                </Form>
            </div>
        )
    }
}
const mapStateToProps = state => {
    return {
        employee: state.employee
    }
}

const mapDispatchToProps = {
    fetchLeaveType
}

ChangePassword = Form.create()(ChangePassword);

export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(ChangePassword));


// WEBPACK FOOTER //
// ./src/routes/Employee/ChangePassword.js